<template>
  <div class="full-item">
    <pdf
      :src="src"
      v-if="src.endsWith('pdf')"
      :page="page"
    ></pdf>
    <div class="full-width flex justify-around">
      <el-button :disabled="page <= 1" @click.stop="page--">上一页</el-button>
      <el-button :disabled="page >= numPages" @click.stop="page++">
        下一页
      </el-button>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf';
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js';

export default {
  components: {
    pdf,
  },

  props: {
    src: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      page: 1,
      numPages: 1,
    };
  },

  watch: {
    src: function(newVal) {
      this.getPdfPages(newVal);
    },
  },

  mounted() {
    this.getPdfPages();
  },

  methods: {
    getPdfPages: function() {
      if (this.src.endsWith('pdf')) {
        let pdfSrc = pdf.createLoadingTask({
          url: this.src,
          CMapReaderFactory,
        }); //解决中文乱码问题
        pdfSrc.promise.then((pdf) => {
          this.numPages = pdf.numPages;
        });
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/pdfShow.vue